import type { EditHackathonData } from '../components/Hackathon/HackathonEditor';
import { parseDraft, serializeDraft } from '../utils/hackathonDraft';
import { blankHackathon } from '../utils/newHackathon';

const STORAGE_KEY = 'hiab.hackathonDraft';

// storage can be blocked (private mode, site data off); the form still works, it just isn't kept
export const loadDraft = () => {
    try {
        return parseDraft(localStorage.getItem(STORAGE_KEY), blankHackathon);
    } catch (e) {
        return null;
    }
};

/** Whether it was kept: storage may be blocked, or full (images take room). */
export const saveDraft = (data: EditHackathonData, createAfterSignIn = false) => {
    try {
        localStorage.setItem(STORAGE_KEY, serializeDraft({ data, createAfterSignIn }));
        return true;
    } catch (e) {
        return false;
    }
};

export const clearDraft = () => {
    try {
        localStorage.removeItem(STORAGE_KEY);
    } catch (e) {
        // nothing to clear
    }
};
